import * as React from 'react';
import StorageAccountsFull from './components/StorageAccountsFull';
var StorageAccountsOption = {
    key: 'storageAccounts',
    titleStringKey: 'optionTitle_storageAccounts',
    searchTermsStringKey: 'optionTitle_storageAccounts',
    fullOptionFormSettings: {
        render: function () { return React.createElement(StorageAccountsFull, null); },
        isDirty: function () { return false; },
        onSave: function () { return Promise.resolve(); },
        onDiscard: function () { },
    },
};
export default StorageAccountsOption;
//# sourceMappingURL=StorageAccountsOption.js.map